// Client-side session-trust state (the backend is external and exposes no device fingerprint).
// - Trusted countries: locations the user has confirmed as "this was me" — never flagged/alerted again.
// - Cooldown: after a new-location alert fires for a country, stay quiet for that country for a window,
//   so the same trip never nags twice even if another session from there appears.
const TRUST_KEY = "bloq_trusted_ccs";
const COOLDOWN_KEY = "bloq_newloc_cooldown";
const COOLDOWN_MS = 12 * 60 * 60 * 1000; // 12h

const listeners = new Set();
export function subscribeTrust(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
function notify() {
  listeners.forEach((l) => l());
}

function read(key) {
  try {
    const v = localStorage.getItem(key);
    return v ? JSON.parse(v) : null;
  } catch {
    return null;
  }
}
function write(key, val) {
  try {
    localStorage.setItem(key, JSON.stringify(val));
  } catch {
    /* ignore */
  }
}

export function getTrustedCcs() {
  const a = read(TRUST_KEY);
  return Array.isArray(a) ? a : [];
}
export function isTrustedCc(cc) {
  return !!cc && getTrustedCcs().includes(cc);
}
export function trustCc(cc) {
  if (!cc) return;
  const set = new Set(getTrustedCcs());
  set.add(cc);
  write(TRUST_KEY, [...set]);
  notify();
}
export function untrustCc(cc) {
  const set = new Set(getTrustedCcs());
  set.delete(cc);
  write(TRUST_KEY, [...set]);
  notify();
}

function getCooldowns() {
  const o = read(COOLDOWN_KEY);
  return o && typeof o === "object" && !Array.isArray(o) ? o : {};
}
export function isCcInCooldown(cc) {
  if (!cc) return false;
  const exp = getCooldowns()[cc];
  return typeof exp === "number" && exp > Date.now();
}
export function startCcCooldown(cc) {
  if (!cc) return;
  const o = getCooldowns();
  o[cc] = Date.now() + COOLDOWN_MS;
  write(COOLDOWN_KEY, o);
}
